var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"full-width-image"},[_c('img',{staticClass:"full-width-image__img",class:'full-width-image__img--' + _vm.getOrientation(),attrs:{"src":_vm.data.image.sizes.large,"srcset":_vm.getSrcSet(),"alt":_vm.data.image.alt}}),_c('figcaption',{staticClass:"full-width-image__caption"},[_vm._v(_vm._s(_vm.data.caption))])])
}
var staticRenderFns = []

export { render, staticRenderFns }